import {
    URLAPI,
    QR_CONFIGURATION_PATH,
    QR_CONFIGURATION_CREATE_PATH,
    QR_CONFIGURATION_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_qr_configuration: {
        data: [],

        status: 0,
        message: {},
    },

    _create_qr_configuration: {
        data: {},
        status: 0,
        message: {},
    },
    _update_qr_configuration: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_QR_CONFIGURATION = "GET_ALL_QR_CONFIGURATION";
export const CREATE_QR_CONFIGURATION = "CREATE_QR_CONFIGURATION";
export const UPDATE_QR_CONFIGURATION = "UPDATE_QR_CONFIGURATION";

export const qr_configuration_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_QR_CONFIGURATION:
            return {
                ...state,
                _get_all_qr_configuration: action.payload,
            };
        case CREATE_QR_CONFIGURATION:
            return {
                ...state,
                _create_qr_configuration: action.payload,
            };
        case UPDATE_QR_CONFIGURATION:
            return {
                ...state,
                _update_qr_configuration: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllQRConfiguration = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${QR_CONFIGURATION_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_QR_CONFIGURATION,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_QR_CONFIGURATION,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_QR_CONFIGURATION,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

//create qr_configuration
export const createQRConfiguration = (token, data) => async (dispatch) => {
    try {
        /*let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }*/
        const response = await axios.post(
            `${URLAPI}${QR_CONFIGURATION_CREATE_PATH}`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_QR_CONFIGURATION,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_QR_CONFIGURATION,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_QR_CONFIGURATION,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateQRConfiguration = (token, id, data) => async (dispatch) => {
    try {
        /*let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }*/
        const response = await axios.patch(
            `${URLAPI}${QR_CONFIGURATION_UPDATE_PATH}${id}/`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_QR_CONFIGURATION,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_QR_CONFIGURATION,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_QR_CONFIGURATION,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_qr_configuration = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
